import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { getClasses } from '@utils/helpers';

import Icon from './Icon';

type Props = {
  value: string;
  className?: string;
  text?: string;
};

const Clipboard = ({ value, className, text }: Props) => {
  const [copied, setCopied] = useState(false);

  const toggleCopied = () => {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <CopyToClipboard text={value} onCopy={toggleCopied}>
      <div className={getClasses('inline cursor-pointer', className)}>
        {copied ? <Icon type="faCheck" /> : <Icon type="faCopy" />}

        {text && <span className="ml-1">{text}</span>}
      </div>
    </CopyToClipboard>
  );
};

export default Clipboard;
